<template>
    <el-dialog title="修改商品分类" :visible.sync="visible" width="30%" @close="close">
        <el-form :model="form" :rules="rules" ref="ruleForm" :inline="true" label-width="80px">
            <el-form-item label="分类名称" prop="name">
                <el-input v-model="form.name" maxlength="20" auto-complete="off"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="ok">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {
    eidtDisplayName,
} from '@servers/base/display/index.js';
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        editData:{
            type: Object,
            default: {},
        },
    },
    data () {
        return {
            dialogVisible: false,
            form: {
                name: "",
            },
            rules: {
                name: [
                    { required: true, message: '分类名称不能为空！' }
                ],
            }
        }
    },
    watch: {
        editData: {
            handler (v) {
                this.form.name = v.name;
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {

    },
    methods: {
        ok () {
            this.$refs.ruleForm.validate(async(valid) => {
                if (valid) {
                    let params = {
                            name: this.form.name,
                            id: this.editData.id,
                        }
                    const res = await eidtDisplayName(params);
                    if (res) {
                        this.clearData()
                        this.$emit("ok");
                    }
                } else {
                    return false;
                }
            });
           
        },
        close () {
            this.clearData();
            this.$emit("close");
        },
        clearData () {
            this.$refs.ruleForm.resetFields();
            this.dialogFormVisible = false;
        }
    },

}
</script>

<style lang="scss" scoped></style>
